import React from 'react';
import { Award, Globe2, MessageCircle, Phone, ShieldCheck, Wifi } from 'lucide-react';
import { heroData, contadoraData, contactData } from '../../data/mock';
import elianaPhoto from '../../assets/eliana.jpeg';
import '../../styles/landing.css';

const HeroSection = () => {
  const scrollToServices = () => {
    const element = document.querySelector('#servicios');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const trustIndicators = [
    { icon: Wifi, label: '100% online' },
    { icon: Globe2, label: 'Atención nacional' },
    { icon: ShieldCheck, label: 'Confidencialidad' }
  ];

  return (
    <section id="inicio" className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-badge animate-fade-in-up">
            <Award size={14} />
            <span>Contadora Pública Colegiada</span>
          </div>
          
          <h1 className="heading-hero hero-title animate-fade-in-up animation-delay-1">
            {contadoraData.nombre}
          </h1>
          
          <p className="hero-subtitle animate-fade-in-up animation-delay-2">
            {heroData.subtitle}
          </p>
          
          <p className="hero-description animate-fade-in-up animation-delay-3">
            {heroData.description}
          </p>

          <div
            className="hero-trust-indicators animate-fade-in-up animation-delay-3"
            aria-label="Beneficios del servicio"
          >
            {trustIndicators.map(({ icon: Icon, label }) => (
              <div className="hero-trust-item" key={label}>
                <Icon size={18} aria-hidden="true" />
                <span>{label}</span>
              </div>
            ))}
          </div>
          
          <div className="hero-buttons animate-fade-in-up animation-delay-4">
            <a
              href={`https://wa.me/${contactData.whatsappNumber}?text=${encodeURIComponent('Hola Eliana, quisiera solicitar una asesoría contable gratuita.')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary hero-whatsapp-cta"
              data-testid="hero-cta-whatsapp"
            >
              <MessageCircle size={19} aria-hidden="true" />
              Consultar por WhatsApp
            </a>
            <button onClick={scrollToServices} className="btn-secondary" data-testid="hero-cta-servicios">
              Ver Servicios
            </button>
          </div>
        </div>
        
        <div className="hero-image-wrapper animate-fade-in-up animation-delay-3">
          <div className="hero-image-frame">
            <div className="hero-image-inner">
              <img 
                src={elianaPhoto} 
                alt={contadoraData.nombre}
                className="hero-portrait"
                data-testid="hero-eliana-photo"
              />
              <a
                href={`https://wa.me/${contactData.whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hero-cpc-badge hero-phone-badge"
                data-testid="hero-phone-badge"
              >
                <Phone size={14} />
                {contactData.whatsapp}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
